// The brand mark is the first character of the app's own NAME, so it follows the locale instead of
// being a letter typed into the markup. Shared by the signed-in shell and the sign-in pages: they
// show the same mark and must not be able to drift apart.
export function brandMark(appName) {
  return (String(appName || '').trim()[0] || '·').toUpperCase();
}